import { paths } from './settings'
import { GlobalState } from './globalState'

export interface AssetEntry {
  name: string
  srcs: string
}

interface BgImageInfo {
  id: string
}

interface LayerData {
  background?: BgImageInfo[]
}

function getImageBundle(): AssetEntry[] {
  const images: AssetEntry[] = []

  // Normal layer images
  images.push(
    ...GlobalState.positionsConfig.flatMap(({ background = [] }: LayerData) =>
      [...background].map(({ id }) => ({
        name: id,
        srcs: `${paths.IMAGES_PATH}main/layers/${id}.png`,
      })),
    ),
  )

  // UI / frame assets that need to live in the Pixi scene
  images.push({
    name: 'ramecek',
    srcs: `${paths.IMAGES_PATH}page/ramecek.png`,
  })

  // Snow particle image (if not in spritesheet, load separately)
  // Note: If p-snow.png doesn't exist, the code will fallback to Graphics-based snowflakes
  // To use the image: add p-snow.png to assets-to-process/spritesheets/st-extra/ and regenerate spritesheet
  // images.push({
  //   name: 'p-snow',
  //   srcs: `${paths.SPRITES_PATH}st-extra/p-snow.png`,
  // })

  return images
}

// const DATA_BUNDLE: AssetEntry[] = [{ name: 'rawActivities', srcs: `${paths.DATA_PATH}activities.json` }]
const SPRITESHEET_BUNDLE: AssetEntry[] = [
  { name: 'st-items', srcs: `${paths.SPRITES_PATH}st-items.json` },
  { name: 'st-extra', srcs: `${paths.SPRITES_PATH}st-extra.json` },
]

export const bundles = {
  // data: DATA_BUNDLE,
  spriteSheets: SPRITESHEET_BUNDLE,
  images: getImageBundle(),
  // TODO: Future?
  // sounds: getItemSoundsBundle()
}
